import en from '../../localization/en.json';
import ua from '../../localization/ua.json';

export const translations = {
    en,
    ua,
};